import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../utils";
import { getAutomationDataAttr } from "../../utils/automationUtils";

import "./styles.scss";

export const Toggle = ({
  checked,
  className,
  disabled,
  id,
  name,
  onBlur,
  onChange,
  onClick,
  testId,
  ...props
}) => {
  const onClickHandler = (e) => {
    onClick(e);
  };

  return (
    <div
      className={createClassNameString(["apti-CL apti-Toggle", className])}
      {...props}
      {...getAutomationDataAttr(`${testId}-${checked ? "on" : "off"}`)}
    >
      <input
        checked={checked}
        className="apti-Toggle__mobile-toggle"
        disabled={disabled}
        id={id ? id : name}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        onClick={onClickHandler}
        type="checkbox"
        {...getAutomationDataAttr(testId)} // cypress isChecked relies on this
      />

      <label htmlFor={id ? id : name} />
    </div>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  testId: PropTypes.string,
};
Toggle.defaultProps = {
  checked: false,
  className: undefined,
  disabled: false,
  id: undefined,
  name: "toggle",
  onBlur: () => {},
  onChange: () => {},
  onClick: () => {},
  testId: undefined,
};
